import React, { useState } from 'react';
import { Button, Form, Spinner } from 'react-bootstrap';

import { TEST_IDS } from './testIds';

const CreateApiKeyForm = ({ onCreate, disabled }) => {
  const [name, setName] = useState('');
  const [validated, setValidated] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setSubmitting(true);
    try {
      const created = await onCreate(name.trim());
      if (created) {
        setName('');
        setValidated(false);
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Form
      noValidate
      validated={validated}
      onSubmit={handleSubmit}
      data-testid={TEST_IDS.CREATE_FORM}
    >
      <div className="row align-items-start">
        <div className="col-md-8">
          <Form.Group controlId="apiKeyName">
            <Form.Label>Key name</Form.Label>
            <Form.Control
              required
              type="text"
              maxLength={120}
              placeholder="e.g. Analytics warehouse sync"
              value={name}
              onChange={(event) => setName(event.target.value)}
              data-testid={TEST_IDS.NAME_INPUT}
            />
            <Form.Control.Feedback type="invalid">
              Please give this key a name.
            </Form.Control.Feedback>
            <Form.Text className="text-muted">
              A label to help you recognize this key later.
            </Form.Text>
          </Form.Group>
        </div>
        <div className="col-md-4 d-flex align-items-center mt-4">
          <Button
            type="submit"
            variant="outline-primary"
            disabled={submitting || disabled}
            data-testid={TEST_IDS.CREATE_BTN}
          >
            {submitting ? (
              <>
                <Spinner animation="border" size="sm" className="me-2" />
                Creating…
              </>
            ) : (
              'Create API key'
            )}
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default CreateApiKeyForm;
